import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash'
import 'react-toastify/dist/ReactToastify.css'; // Need this if not toast position won't work

import { Toaster, Error } from './features';
import { SandboxModule } from 'modules'
import {
	LandingScreen,
	LegalScreen,
	PricingScreen,
	LoadingScreen, 
	MainScreen, 
	AuthScreen, 
	GettingStartedScreen, 
	ErrorScreen,
	RedirectionScreen,
	DeeplinkScreen
} from './screens';

import * as cssTheme from '../src/theme'

const App = props => {
    const {} = props;
    const user = useSelector(state => state.auth.user)
    React.useEffect(() => {
        const theme = user ? user['theme'] : cssTheme.dark
        for (const [key, value] of Object.entries(theme)) {
			document.documentElement.style.setProperty(key,value);
		}

		for (const [key, value] of Object.entries(cssTheme.base)) {
			document.documentElement.style.setProperty(key,value);
		}
    },[])

    let routes = (
		<Switch>
			{process.env.REACT_APP_ENV === 'DEVELOPMENT' && <Route path="/" exact component={(props) => <LandingScreen/>}/>}
			<Route path="/loading" exact component={(props) => <LoadingScreen pathName=''/>}/>

			{/* Static */}
			{process.env.REACT_APP_ENV === 'DEVELOPMENT'&& <Route path="/legal/terms-of-service" exact component={(props) => <LegalScreen type='terms-of-service'/>}/>}
			{process.env.REACT_APP_ENV === 'DEVELOPMENT' && <Route path="/legal/privacy-policy" exact component={(props) => <LegalScreen type='privacy-policy'/>}/>}
			{process.env.REACT_APP_ENV === 'DEVELOPMENT' && <Route path="/pricing" exact component={(props) => <PricingScreen/>}/>}

			{/* Auth */}
			<Route path="/login-desktop" exact component={(props) => <AuthScreen type='deeplink'/>}/>
			<Route path="/login" exact component={(props) => <AuthScreen type='login'/>}/>
			<Route path="/login-premium" exact component={(props) => <AuthScreen type='login' premium/>}/>
			<Route path="/register" exact component={(props) => <AuthScreen type='register'/>}/>
			<Route path="/forgot-password" exact component={(props) => <AuthScreen type='forgot_password'/>}/>
			<Route path="/getting-started" exact component={(props) => <GettingStartedScreen/>}/>

			{/* App */}
			<Route path="/app/:activePageID" exact component={(props) => <MainScreen/>}/>

			{/* Misc */}
			<Route path="/redirect/:id" exact component={RedirectionScreen}/>
			<Route path="/error" component={() => <ErrorScreen error='page-not-found'/>}/>
			{!user && <Redirect to='/loading'/>}
		</Switch>
    )

	return (
        <div>
			{routes}
			{user && <Toaster/>}
			<Error/>
		</div>
    )
}

export default App;